<template>
    <div v-loading="loading">
        <el-tabs v-model="activeName">
            <el-tab-pane label="选择车型" name="selSeries">
                <div class="search-btn-list">
                    <div class="tab-list">
                        <span :class="{ check: checkId === item }" v-for="item in tabOptions" :key="item" @click="changeTab(item)">{{ item }}</span>
                    </div>
                    <div>
                        <el-button size="small" class="search-btn btn-primary" @click="searchCarModel">搜索车型</el-button>
                    </div>
                </div>
                <div class="dialog-s-content">
                    <div v-if="!processError"></div>
                    <el-cascader-panel
                        v-if="processError"
                        ref="cascader"
                        class="dialog-cascader-panel"
                        v-model="checkPartList"
                        :key="checkId"
                        :options="cascaderSeriesOptions"
                        :collapse-tags="false"
                        :props="propObjs"
                        @change="changeCascaderList"
                    />
                    <div class="cascader-checked">
                        <div class="checked-item" v-for="(item, index) in checkPanelList" :key="index">
                            <div class="row-model">
                                <el-tooltip effect="dark" :content="item[4].split('{$}')[1]" placement="bottom">
                                    <span>{{ item[4].split('{$}')[1] }}</span>
                                </el-tooltip>
                            </div>
                            <i class="el-icon-close" @click="deleteRow(item)"></i>
                        </div>
                    </div>
                </div>
                <div style="text-align: right; padding: 16px">
                    <el-button
                        size="small"
                        type="warning"
                        class="search-btn"
                        v-if="isShowSets"
                        @click="
                            () => {
                                autoSSetVisible = true;
                            }
                        "
                        >设置通用车型生成规则</el-button
                    >
                    <el-button size="small" class="search-btn btn-primary" @click="clearPanelList">清空</el-button>
                    <el-button size="small" class="search-btn btn-primary" @click="confirmButton">确定</el-button>
                </div>
            </el-tab-pane>
            <!-- <el-tab-pane label="发动机号" name="engine">
                <div class="search-ctn">
                    <div class="search-ctn-left">
                        <div class="search-name">发动机</div>
                        <el-input
                            class="search-item"
                            style="width: 150px; margin-bottom: 10px"
                            size="small"
                            v-model="searchData.engine"
                            placeholder="请输入发动机号"
                        ></el-input>
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" style="margin-bottom: 10px" @click="handleSearch">查询</el-button>
                    </div>
                </div>
                <div class="dialog-s-content table-ctn" style="display: block">
                    <div>
                        <el-table
                            ref="seriesTable"
                            :header-cell-style="{ background: '#F2F6FC' }"
                            :data="tableData"
                            border=""
                            height="470px"
                            style="width: 100%; margin-bottom: 10px; overflow-y: auto"
                        >
                            <el-table-column type="selection" width="55" fixed="left"></el-table-column>
                            <el-table-column label="发动机" prop="EngineType" show-overflow-tooltip></el-table-column>
                            <el-table-column label="品牌" prop="BrandName" show-overflow-tooltip></el-table-column>
                            <el-table-column label="车型" prop="SeriesName" show-overflow-tooltip></el-table-column>
                            <el-table-column label="排量" prop="Emission" width="80" show-overflow-tooltip></el-table-column>
                            <el-table-column label="年款" prop="ModelYear" width="80" show-overflow-tooltip></el-table-column>
                            <el-table-column label="销售型" prop="SaleModel" min-width="150" show-overflow-tooltip></el-table-column>
                            <el-table-column label="驱动" prop="DriveStyle" min-width="100" show-overflow-tooltip></el-table-column>
                            <el-table-column label="变速箱" prop="TransmissionType" min-width="100" show-overflow-tooltip></el-table-column>
                        </el-table>
                    </div>
                    <div class="dialog-pagination-ctn" style="text-align: left">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="searchData.page"
                            :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                            :page-size="searchData.limit"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="tableDataLength"
                        ></el-pagination>
                    </div>
                </div>
                <div style="text-align: right; padding: 16px">
                    <el-button size="small" class="search-btn btn-primary" @click="clearSel">清空</el-button>
                    <el-button size="small" class="search-btn btn-primary" @click="confirmByE">确定</el-button>
                </div>
            </el-tab-pane> -->
        </el-tabs>
        <el-dialog :close-on-click-modal="false" title="设置通用车型生成规则" @close="closeAutoSDialog" :visible.sync="autoSSetVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="autoSSetVisible">
                <AutoSeriesSets @closeDialog="closeAutoSDialog"></AutoSeriesSets>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="车型搜索"
            :visible.sync="searchVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-model-dialog"
            style="margin-left: -500px"
        >
            <div v-if="searchVisible">
                <SearchSearies ref="searchSearise" @addToSelected="addToSelected" :selectOptions="checkPanelList" @closeDialog="closeSearchDialog"></SearchSearies>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import pageLimitMixin from '@/mixins/pageLimitMixin';
import AutoSeriesSets from '@/components/common/autoSeriesSets.vue';
import SearchSearies from '@/components/common/searchSearies.vue';
export default {
    mixins: [pageLimitMixin],
    components: { AutoSeriesSets, SearchSearies },
    props: {
        visible: Boolean,
        showSets: Boolean,
        clearOptions: {
            type: Array
        },
        selectOptions: {
            type: Array
        }
    },
    data() {
        return {
            checkId: '',
            tabOptions: [],
            // searchAutoList: [],
            checkPartList: [], // 当前级联选中项
            checkAllList: {}, // 全部级联选中项，键值对形式
            seriesOptions: [], // 当前级联列表
            loading: false,
            searchVisible: false,
            processError: true, // 为了处理未知原因的切换报错问题
            activeName: 'selSeries',
            tableData: [],
            tableDataLength: 0,
            searchData: {
                engine: '',
                page: 1,
                limit: 15
            },
            isShowSets: false,
            autoSSetVisible: false,
            propObjs: {
                value: 'value', //设置每个menu的ID值
                label: 'label', //设置每个menu的name值
                children: 'children', //子级
                multiple: true
            }
        };
    },
    computed: {
        checkPanelList() {
            let list = Object.values(this.checkAllList);
            if (!list || list.length === 0) return [];
            let partArr = Object.values(list);
            return partArr.reduce((p, i) => [...p, ...i], []);
        },
        cascaderSeriesOptions() {
            if (!this.seriesOptions) return [];
            return this.seriesOptions;
        }
    },
    // watch: {
    //     visible(val) {
    //         if (val) {
    //             console.log('watch-visible')
    //             console.log(val)
    //             // 清除弹框外清除项
    //             if (Array.isArray(this.clearOptions) && this.clearOptions.length > 0) {
    //                 this.clearOptions.forEach(ele => {
    //                     let arr = this.checkPartList.filter(f => f[4].AutoSerieId === ele.AutoSerieId);
    //                     if (arr.length > 0) this.deleteRow(arr[0]);

    //                     let row = this.tableData.find(f => f.AutoSerieId === ele.AutoSerieId);
    //                     if (row) this.$refs.seriesTable.toggleRowSelection(row, false);
    //                 });
    //             }
    //         }
    //     }
    // },
    mounted() {
        if (this.showSets) this.isShowSets = this.showSets;
        this.addToAllCheck(this.selectOptions);
        this.getTabOptions();
    },
    methods: {
        checkSearchVisible() {
            return this.searchVisible;
        },
        // 删除一行
        deleteRow(row) {
            let index = -1;
            let vArr = this.$refs.cascader.value;
            if (Array.isArray(vArr)) {
                index = vArr.findIndex(item => {
                    return item[4].split('{$}')[0] === row[4].split('{$}')[0];
                });
            }

            if (~index) {
                this.$refs.cascader.value.splice(index, 1);
                this.$refs.cascader.handleCheckChange();
            } else {
                let letter = -1; // 首字母所在位置
                let index2 = -1; // 删除项所在位置
                let list = Object.entries(this.checkAllList);
                list.forEach((ele, eleIndex) => {
                    if (index2 === -1) {
                        letter = ele[0];
                        if (ele[1]) index2 = ele[1].findIndex(i => i[4].split('{$}')[0] === row[4].split('{$}')[0]);
                    }
                });
                if (letter !== -1 && index2 !== -1) {
                    this.checkAllList[letter].splice(index2, 1);
                }

                let arrIndex = this.checkPanelList.findIndex(f => f[4].split('{$}')[0] === row[4].split('{$}')[0]);
                if (~arrIndex) {
                    this.checkPanelList.splice(arrIndex, 1);
                    this.$set(this.checkPanelList);
                    this.$forceUpdate();
                }
            }
        },
        // 切换列表
        changeTab(val) {
            this.checkId = val;
            this.processError = false;
            this.getAutoSeriesByBFL();
        },
        // 更改级联选中项
        changeCascaderList(value) {
            this.$set(this.checkAllList, this.checkId, this.checkPartList);
        },
        // 清空选中列表
        clearPanelList() {
            this.checkPartList = [];
            this.checkAllList = [];
        },
        // 确定选中列表
        confirmButton() {
            if (this.checkPanelList) {
                this.searchVisible = false;
                this.$emit('confirmButton', this.checkPanelList);
            }
        },
        // 获取品牌列表
        getAutoSeriesByBFL() {
            return new Promise(resolve => {
                let that = this;
                let checkList = this.checkAllList;
                let params = { firstLetter: this.checkId };
                that.$util.getAutoSeriesByBFL(params).then(data => {
                    if (!data || data.length < 1) return;
                    this.seriesOptions = data;
                    this.processError = true;

                    if (Object.keys(checkList).length > 0) {
                        this.checkPartList = this.checkAllList[this.checkId];
                    }
                    resolve();
                });
            });
        },
        // 获取字母列表
        getTabOptions() {
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: `/api/Auto/GetAllAutoBrands`
                    })
                    .then(res => {
                        this.tabOptions = Object.keys(res.data);
                        this.checkId = this.tabOptions[0];

                        this.getAutoSeriesByBFL().then(() => {
                            resolve();
                        });
                    })
                    .catch(() => {});
            });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        getTableData() {
            if (!this.searchData.engine) {
                this.$message.warning('请输发动机号');
                return;
            }
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetAutoSeriesByEngine',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        this.tableData = data;
                        this.tableDataLength = res.count;
                    } else {
                        this.tableData = [];
                        this.tableDataLength = 0;
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        clearSel() {
            this.$refs.seriesTable.clearSelection();
        },
        confirmByE() {
            let sel = this.$refs.seriesTable.selection;
            if (sel) {
                this.$emit('confirmButton', sel);
            }
        },
        closeAutoSDialog() {
            this.autoSSetVisible = false;
        },
        searchCarModel() {
            this.searchVisible = true;
        },
        addToSelected(items) {

            if (items && items.length > 0) {
                let checkId = this.checkId; //当前的字母

                let letter = [];
                for (let index = 0; index < items.length; index++) {
                    const element = items[index];
                    let arrx = letter.filter(f => f === element.FirstLetter);
                    if (arrx.length == 0) {
                        letter.push(element.FirstLetter);
                    }
                }

                let checkArr = [];
                if (Object.keys(this.checkAllList).length > 0) {
                    checkArr = this.checkAllList[checkId]?this.checkAllList[checkId]:[];
                }
                 
                let lIndex = letter.findIndex(f => f == checkId);
                if (lIndex == -1 && checkArr.length > 0) {
                    letter.push(checkId);
                    for (let j = 0; j < checkArr.length; j++) {
                        const ele = checkArr[j];

                        let autoSerie = {
                            BrandName: ele[0],
                            SeriesName: ele[1],
                            Emission: ele[3],
                            ModelYear: ele[2],
                            AutoSerieId: ele[4].split('{$}')[0],
                            ModelDesc: ele[4].split('{$}')[1],
                            FirstLetter: checkId
                        };
                        items.push(autoSerie);
                    }
                }

                for (let index = 0; index < letter.length; index++) {
                    const lett = letter[index];
                    if (Object.keys(this.checkAllList).length > 0) {
                        let keys = Object.keys(this.checkAllList);
                        let index = keys.findIndex(f => f == lett);
                        if (index > -1) {
                            let arrx = items.filter(f => f.FirstLetter === lett);
                            if (arrx.length != 0) {
                                for (let j = 0; j < arrx.length; j++) {
                                    const ele = arrx[j];
                                    let arr = [];
                                    arr.push(ele.BrandName);
                                    arr.push(ele.SeriesName);
                                    arr.push(ele.ModelYear);
                                    arr.push(ele.Emission);
                                    arr.push(ele.AutoSerieId + '{$}' + ele.ModelDesc);

                                    let arrCA = this.checkAllList[lett].filter(f => f[4].split('{$}')[0] === ele.AutoSerieId);
                                    if (arrCA.length == 0) {
                                        this.checkAllList[lett].push(arr);
                                    }
                                }
                            }
                        } else {
                            let checkList = [];
                            for (let j = 0; j < items.length; j++) {
                                const ele = items[j];
                                if (ele.FirstLetter == lett) {
                                    let arrx = checkList.filter(f => f[4].split('{$}')[0] === ele.AutoSerieId);
                                    let arr = [];
                                    if (arrx.length == 0) {
                                        arr.push(ele.BrandName);
                                        arr.push(ele.SeriesName);
                                        arr.push(ele.ModelYear);
                                        arr.push(ele.Emission);
                                        arr.push(ele.AutoSerieId + '{$}' + ele.ModelDesc);
                                        checkList.push(arr);
                                    }
                                }
                            }
                            if (checkList.length > 0) {
                                this.$set(this.checkAllList, lett, checkList);
                            }
                        }
                    } else {
                        let checkList = [];
                        for (let j = 0; j < items.length; j++) {
                            const ele = items[j];
                            if (ele.FirstLetter == lett) {
                                let arrx = checkList.filter(f => f[4].split('{$}')[0] === ele.AutoSerieId);
                                let arr = [];
                                if (arrx.length == 0) {
                                    arr.push(ele.BrandName);
                                    arr.push(ele.SeriesName);
                                    arr.push(ele.ModelYear);
                                    arr.push(ele.Emission);
                                    arr.push(ele.AutoSerieId + '{$}' + ele.ModelDesc);
                                    checkList.push(arr);
                                }
                            }
                        }
                        if (checkList.length > 0) {
                            this.$set(this.checkAllList, lett, checkList);
                        }
                    }
                }

                this.checkPartList = this.checkAllList[checkId];
                if (lIndex > -1 && this.$refs.cascader) {
                    this.$refs.cascader.handleCheckChange();
                }
            }
            this.searchVisible = false;
        },
        addToAllCheck(items) {
            if (items && items.length > 0) {
                let letter = [];
                for (let index = 0; index < items.length; index++) {
                    const element = items[index];
                    let arrx = letter.filter(f => f === element.FirstLetter);
                    if (arrx.length == 0) {
                        letter.push(element.FirstLetter);
                    }
                }

                for (let index = 0; index < letter.length; index++) {
                    const lett = letter[index];

                    let checkList = [];
                    for (let j = 0; j < items.length; j++) {
                        const ele = items[j];
                        if (ele.FirstLetter == lett) {
                            console;
                            let arrx = checkList.filter(f => f[4].split('{$}')[0] === ele.AutoSerieId);
                            let arr = [];
                            if (arrx.length == 0) {
                                arr.push(ele.BrandName);
                                arr.push(ele.SeriesName);
                                arr.push(ele.ModelYear);
                                arr.push(ele.Emission);
                                arr.push(ele.AutoSerieId + '{$}' + ele.ModelDesc);
                                checkList.push(arr);
                            }
                        }
                    }
                    if (checkList.length > 0) {
                        this.$set(this.checkAllList, lett, checkList);
                    }
                }
            }
        },
        recoverData(items) {
            if (items && items.length > 0) {
                let checkId = this.checkId; //当前的字母
                for (let index = 0; index < items.length; index++) {
                    const element = items[index];
                    let arrx = this.checkPanelList.filter(f => f[4].AutoSerieId === items[index].AutoSerieId);
                    let arr = [];
                    if (arrx.length == 0) {
                        arr.push(element.BrandName);
                        arr.push(element.SeriesName);
                        arr.push(element.ModelYear);
                        arr.push(element.Emission);
                        arr.push({
                            AutoSerieId: element.AutoSerieId,
                            BrandId: element.BrandId,
                            ModelDesc: element.ModelDesc,
                            IsMatch: false
                        });
                        this.checkPanelList.push(arr);
                    }
                    if (Object.keys(this.checkAllList).length > 0) {
                        let arrCA = this.checkAllList[checkId].filter(f => f[4].AutoSerieId === items[index].AutoSerieId);
                        if (arrCA.length == 0) {
                            this.checkAllList[checkId].push(arr);
                        }
                        this.checkPartList = this.checkAllList[checkId];
                    }
                }
            }
        },
        closeSearchDialog() {
            this.searchVisible = false;
        }
    }
};
</script>

<style lang="less">
.dialog-cascader-panel {
    width: 870px;
    height: 500px;
    overflow-x: visible;

    .el-cascader-node__label {
        overflow: visible;
        text-overflow: clip;
    }
    .el-scrollbar__bar {
        display: none;
    }
    .el-cascader-menu__wrap {
        height: 500px;
        margin: 0 !important;
    }
}
#search-model-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        width: 1000px;
        box-shadow: 0 0 9px 3px #999;
    }
    .add-row-dialog {
        width: 340px;
        height: auto;
        .form-div {
            margin-top: 20px;
        }
        .dialog-footer {
            text-align: right;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>

<style lang="less" scoped>
.row-model {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.search-btn-list {
    display: flex;
    justify-content: space-between;
}
.tab-list {
    display: flex;
    span {
        min-width: 25px;
        height: 25px;
        padding: 5px;
        margin: 5px;
        font-size: 14px;
        font-weight: 600;
        text-align: center;
        cursor: pointer;
    }
    .check {
        color: #fff;
        background-color: #8c98cc;
    }
}
.dialog-s-content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    height: 500px;
    padding: 0;
    .dialog-cascader-panel {
        flex: 1;
    }
    .cascader-checked {
        margin-left: 24px;
        width: 29%;
        height: 100%;
        flex-shrink: 0;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        overflow: auto;
        .checked-item {
            margin: 8px;
            padding: 8px;
            border-radius: 4px;
            background-color: #f4f4f4;
            display: flex;
            justify-content: space-between;
            cursor: pointer;
            .el-icon-close {
                display: flex;
                align-items: center;
            }
        }
    }
}
</style>
